import { IThreeDSecureProviderContractCreate } from './three-d-secure-provider-contract-create.interface';
import { EntityStatus } from '../../organisations/enums/entity-status.enum';

export interface IThreeDSecureProviderContractUpdate
  extends Partial<IThreeDSecureProviderContractCreate> {
  status?: EntityStatus;
}
